import React from 'react';

import { Paper } from '@mui/material';
import {
  ContractWorkflowCollaborators,
  WorkflowCollaboratorCardVariant,
} from 'src/components/workflow';
import { makeStyles } from 'tss-react/mui';

const useAddCollaboratorsStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  header: {
    padding: theme.spacing(2, 2, 3, 2),
  },
  teamContainer: {
    padding: theme.spacing(2),
    width: 'unset',
  },
}));

export function AddCollaboratorsSection({ workflowId }: { workflowId: UUID }) {
  const { classes } = useAddCollaboratorsStyles();

  return (
    <div className={classes.container}>
      <AddCollaboratorsCard workflowId={workflowId} />
    </div>
  );
}

export function AddCollaboratorsCard({ workflowId }: { workflowId: UUID }) {
  const { classes } = useAddCollaboratorsStyles();

  return (
    <Paper>
      <ContractWorkflowCollaborators
        className={classes.teamContainer}
        variant={WorkflowCollaboratorCardVariant.Outline}
        workflowId={workflowId}
      />
    </Paper>
  );
}
